import React, { useContext, useEffect, useState } from "react";
import ApiRequest from "../Common/restservice";
import { useNavigate } from "react-router-dom";
import {
  companyColors,
  companyColorsname,
  errorToast,
  individualColors,
  individualColorsname,
  ranknames,
} from "../Common/showtoast";
import moment from "moment";
import ThemeContext from "../themecontext";

function Teamlist() {
  const [fromDate, setFromDate] = useState(
    moment().subtract(60, "days").format("YYYY-MM-DD")
  );
  const { theme } = useContext(ThemeContext);

  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));
  const [tableData, setTableData] = useState([]);
  const [level, setLevel] = useState("");
  const [pageno, setsetPageno] = useState(1);
  const navigate = useNavigate();
  useEffect(() => {
    GetTeamList();
  }, [pageno]);
  const GetTeamList = async () => {
    let jsoninput = {
      fromdate: fromDate ? moment(fromDate).format("MM/DD/YYYY") : "",
      todate: toDate ? moment(toDate).format("MM/DD/YYYY") : "",
      level: level,
      pageno,
    };
    let url = "GetHirachyTable.asp";
    let res = await ApiRequest(url, "POST", jsoninput, {
      Authorization: localStorage.getItem("token"),
    });
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Session Expired") {
        localStorage.clear();
        navigate("/login");
      }
      setTableData([]);
      return;
    }
    setTableData(res.items);
  };
  return (
    <section className="content">
      <div className="row">
        <div className="col-xl-12 col-lg-12 col-md-12">
          <div className="card">
            <div className="card-header">
              <h3
                className="card-title text-color-1"
                style={{ fontWeight: "200", fontSize: "22px" }}
              >
                Level Team
              </h3>
            </div>

            <div className="card-body">
              <div className="d-md-flex mt-4 mb-2">
                <div className="col-md-3">
                  <div className="form-group">
                    <div className="input-group">
                      <span className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fa fa-calendar"></i>
                        </span>
                      </span>
                      <input
                        type="date"
                        className="form-control daterange-single"
                        id="start_date"
                        name="start_date"
                        placeholder="From Date"
                        autoComplete="off"
                        onChange={(e) => {
                          setFromDate(e.target.value);
                        }}
                        value={fromDate}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <div className="input-group">
                      <span className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fa fa-calendar"></i>
                        </span>
                      </span>
                      <input
                        type="date"
                        className="form-control daterange-single"
                        id="end_date"
                        name="end_date"
                        placeholder="To Date"
                        autoComplete="off"
                        onChange={(e) => {
                          setToDate(e.target.value);
                        }}
                        value={toDate}
                      />
                    </div>
                  </div>
                </div>
                {/* <div className="col-md-3">
                                <div className="form-group">
                                    <div className="input-group">
                                        <select className="form-control" onChange={(e) => {
                                            setLevel(e.target.value);
                                        }}>
                                            <option value="">-- Select Level --</option>
                                            <option value="">All</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                            <option value="6">6</option>
                                            <option value="7">7</option>
                                            <option value="8">8</option>
                                            <option value="9">9</option>
                                            <option value="10">10</option>
                                            <option value="11">11</option>
                                            <option value="12">12</option>
                                        </select>
                                    </div>
                                </div>
                            </div> */}
                <div className="col-md-3 text-left">
                  <div className="form-group">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={(e) => {
                        GetTeamList();
                      }}
                    >
                      {" "}
                      Search{" "}
                    </button>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                <table
                  className="table table-vcenter text-nowrap mb-0 table-bordered border-top"
                  style={{ textAlign: "center" }}
                >
                  <thead className="">
                    <tr>
                      <th>S.No</th>
                      <th>Ac. No</th>
                      <th>Name</th>
                      <th>Package</th>
                      <th>Sponsor Ac. No</th>
                      <th>Rank</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.length <= 0 ? (
                      <tr>
                        <td colSpan="7">No Details Found</td>
                      </tr>
                    ) : (
                      tableData.map((item, index) => (
                        <tr key={index}>
                          <td>{(pageno - 1) * 100 + (index + 1)}</td>
                          <td
                            style={{
                              color:
                                item.package === "10000"
                                  ? individualColorsname[item.rank]
                                  : item.package === "20000"
                                  ? companyColorsname[item.rank]
                                  : theme === "dark" ? "white" : "black",
                            }}
                          >
                            {item.memberid}
                          </td>
                          <td>{item.memberidname}</td>
                          <td>{item.package}</td>
                          <td>{item.sponsor}</td>
                          <td
                            style={{
                              color:
                                item.package === "10000"
                                  ? individualColorsname[item.rank]
                                  : item.package === "20000"
                                  ? companyColorsname[item.rank]
                                  : theme === "dark" ? "white" : "black",
                            }}
                          >
                            {item.rank}
                          </td>
                          <td>{item.jdate}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              <div className="row mt-2">
                {pageno > 1 && (
                  <button
                    className="btn btn-primary col-2"
                    onClick={() => setsetPageno(pageno - 1)}
                  >
                    Prev
                  </button>
                )}
                {tableData.length >= 100 && (
                  <button
                    className="btn btn-primary ms-auto  col-2"
                    onClick={() => setsetPageno(pageno + 1)}
                  >
                    Next
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Teamlist;
